import Typography from "@mui/material/Typography";
import React from "react";
import {Box, CircularProgress, Paper, useTheme} from "@mui/material";

function LoadingComponent() {
    const theme = useTheme()

    return (
        <React.Fragment>
            <Paper sx={{backgroundColor: theme.palette.custom.loadingBackground + ' !important'}}>
                <Box display="flex" flexDirection="column" flexGrow={1} alignItems="center" p={5}>
                    <CircularProgress/>
                    <Box m={2}/>
                    <Typography variant="h1">Loading...</Typography>
                    <Typography variant="body1">If loading continues, please try refreshing the page.</Typography>
                </Box>
            </Paper>
        </React.Fragment>
    )
}

export default LoadingComponent
